import Swiper from 'swiper/swiper-bundle';
import barba from '@barba/core';

export class WbCommerce {
  constructor() {
    this.bindListeners();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.initSliders();
      this.initCheckout();
      resolve();
    });
  }

  bindListeners() {
    document.querySelector('body')._addCustomEventListener('click', '.js-add-to-cart', this.addToCart.bind(this));
    document.querySelector('body')._addCustomEventListener('click', '.js-cart-remove', this.removeFromCart.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('change', '.wb-checkout__item-qty', this.updateCart.bind(this));
    document.querySelector('body')._addCustomEventListener('click', '.js-update-cart', this.submitCode.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.wb-checkout-sidebar__button--validate', this.validateForm.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('submit', '.wb-checkout-sidebar__form', this.updateCart.bind(this));
    document
      .querySelector('body')
      ._addCustomEventListener('change', '.wb-event__ticket-input-qty', this.updateTicketTotal.bind(this));
  }

  initSliders() {
    const featured = document.querySelector('.wb-product-gallery__slider--featured');
    const thumbnails = document.querySelector('.wb-product-gallery__slider--thumbnails');
    const featuredParams = {};

    const thumbnailsSlider = new Swiper(thumbnails, {
      slidesPerView: 4,
      spaceBetween: 15,
      loop: false,
      clickable: true,
      navigation: {
        nextEl: '.wb-swiper-btm-bar__arrow--next',
        prevEl: '.wb-swiper-btm-bar__arrow--prev',
        disabledClass: 'wb-swiper-btm-bar__arrow--disabled',
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
        1200: {
          spaceBetween: 30,
          slidesPerView: 5,
        },
      },
    });

    if (thumbnailsSlider.el) {
      featuredParams.thumbs = {
        swiper: thumbnailsSlider,
      };
    }

    const featuredSlider = new Swiper(featured, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      ...featuredParams,
    });
  }

  initCheckout() {
    document.dispatchEvent(new Event('_checkout_loaded'));
  }

  toggleAjaxOverlay(forceClose = false) {
    const overlayIsActive = document.querySelector('#page').classList.contains('wb-load-overlay');

    if (!overlayIsActive && !forceClose) {
      const icon = document.createElement('div');
      icon.classList.add('wb-load-overlay__icon');

      document.querySelector('#page').classList.add('wb-load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.wb-load-overlay')?.classList.remove('wb-load-overlay');
      document.querySelectorAll('.wb-load-overlay__icon')?.forEach(icon => icon._remove());
    }
  }

  addToCart(e) {
    e.preventDefault();

    const _this = this;
    const form = e.targetElement.closest('form');
    const purchasables = [];

    this.updateCart(e, false).then(() => {
      document.querySelectorAll('.wb-product [data-purchasable],.wb-event [data-purchasable] ').forEach(element => {
        const purchasable = JSON.parse(element.dataset.purchasable);

        if (purchasable.qty > 0 || purchasable.type == 'event') {
          purchasables.push({
            item_name: purchasable.title,
            item_id: purchasable.id,
            item_category: purchasable.type,
            item_sku: purchasable.sku,
            item_image: purchasable.image,
            item_url: purchasable.url,
            price: parseFloat(purchasable.price),
            quantity: parseInt(purchasable.qty),
          });
        }
      });

      window.dispatchEvent(new CustomEvent('craft.commerce.add_to_cart', { detail: purchasables }));
      form.reset();
      _this.toggleAjaxOverlay(true);

      if (form.classList.contains('wb-event__form')) {
        _this.updateTicketTotal();
        const cartUrl = document.querySelector('.wb-menu__item__cart').href;
        window.location.href = cartUrl;
      }
    });
  }

  updateCartQty() {
    return fetch('/actions/commerce/cart/get-cart', {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then(data => {
        const { totalQty } = data.cart;
        document.querySelectorAll('.wb-cart-qty')?.forEach(qty => (qty.innerText = totalQty));
      })
      .catch(error => console.error(error));
  }

  updateCart(e, checkout = true, prevent = true, redirect = false) {
    if (prevent) e.preventDefault();

    const _this = this;
    let form = e;

    if (e.target) form = e.target.closest('form');

    const formData = new FormData(form);

    _this.toggleAjaxOverlay();

    return fetch('/actions/commerce/cart/update-cart', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: formData,
    })
      .then(response => {
        if (!response.ok) {
          if (response.status !== 400) {
            _this.toggleAjaxOverlay();
            throw Error(response.statusText);
          }
        }
        return response.json();
      })
      .then(data => {
        if (data.errors) {
          _this.addCartNotices(data);
          _this.addFormErrors(data.errors);
          _this.toggleAjaxOverlay();
        } else {
          _this.updateCartQty();
          _this.addCartNotices(data);
          if (redirect) {
            _this.toggleAjaxOverlay();
            barba.go(data.redirect);
          } else if (checkout) {
            _this.getCheckoutStep(formData).then(() => {
              _this.addCartNotices(data);
            });
          }
        }
      })
      .catch(error => console.error(error));
  }

  updateTicketTotal() {
    const tickets = document.querySelectorAll('.wb-event__ticket');
    const totalQty = document.querySelector('.wb-event__total-qty');
    const totalPrice = document.querySelector('.wb-event__total-price-currency');
    const summary = [...tickets].reduce(
      (acc, ticket) => {
        const qty = Number(ticket.querySelector('.wb-event__ticket-input-qty').value);
        const price = parseFloat(
          ticket.querySelector('.wb-event__ticket-price-el').textContent.replace(',', '.'),
        ).toFixed(2);

        acc.qty += qty;
        acc.total += qty * price;
        return acc;
      },
      { qty: 0, total: 0 },
    );

    totalQty.textContent = totalQty.textContent.replace(/\d+/g, summary.qty);
    const totalPriceTVQ = summary.total * 0.09975;
    const totalPriceTPS = summary.total * 0.05;
    const totalPriceTaxIn = summary.total + totalPriceTVQ + totalPriceTPS;
    totalPrice.textContent = totalPriceTaxIn.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });

    // totalPrice.textContent = summary.total.toLocaleString('fr-CA', { style: 'currency', currency: 'CAD' });
  }

  getCheckoutStep(formData) {
    const _this = this;

    return fetch(formData.get('url'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    })
      .then(response => {
        if (!response.ok) {
          this.toggleAjaxOverlay();
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.text())
      .then(data => {
        const PARSER = new DOMParser();
        const DOC = PARSER.parseFromString(data, 'text/html');
        const currentCheckout = document.querySelector('.wb-checkout');
        const newCheckout = DOC.querySelector('.wb-checkout');
        const isCart = document.querySelector('.checkout-cart');

        if (isCart) {
          currentCheckout.replaceWith(newCheckout);
        } else {
          const currentSidebar = document.querySelector('.wb-checkout-sidebar');
          const newSidebar = DOC.querySelector('.wb-checkout-sidebar');
          currentSidebar.replaceWith(newSidebar);
        }

        _this.toggleAjaxOverlay();
      })
      .catch(error => console.error(error));
  }

  removeFromCart(e) {
    const input = e.target.closest('.wb-checkout__item').querySelector('.wb-checkout__item-removed');
    input.checked = true;

    this.updateCart(e);
  }

  submitCode(e) {
    e.preventDefault();

    this.updateCart(e, true);
  }

  validateForm(e) {
    const button = e.target.closest('button') ?? e.target;
    const formId = button.getAttribute('form');
    const form = document.querySelector(`#${formId}`);

    if (form.checkValidity() && form.getAttribute('id') !== 'paymentForm') {
      e.preventDefault();
      this.updateCart(form, false, false, true);
    }
  }

  addFormErrors(errors) {
    const keys = Object.keys(errors);

    document.querySelectorAll('.--error')?._remove();

    keys?.forEach(error => {
      let id = error.replace('.', '-');
      const base = document.createElement('div');
      const ref = document.querySelector(`#${id}`);

      if (error === 'billingAddress') id = 'billingAddress-countryCode';
      if (error === 'shippingAddress') id = 'shippingAddress-countryCode';

      base.classList.add('--error');
      base.innerHTML = errors[error][0];

      if (ref) document.querySelector('body')._insertAfter(base, ref);
    });
  }

  addCartNotices(response) {
    const noticeMsg = document.querySelector('.noticeMsg');

    if (noticeMsg) {
      let statusMsg = '<div class="h4">' + response.message + '</div>';

      if (response.errors) {
        statusMsg += '<ul>';

        Object.values(response.errors).forEach(val => {
          statusMsg += '<li>' + val + '</li>';
        });

        statusMsg += '</ul>';

        noticeMsg.classList.add('errorMsg');
      } else {
        noticeMsg.classList.add('successMsg');
      }

      noticeMsg.innerHTML = statusMsg;
      WbScrollTo.scrollTo({ element: 'main' });
    }
  }
}
